import { API } from "@/lib/api";
import { formatApiErrorDetail } from "@/lib/auth";

async function call(path, { method = "GET", body } = {}) {
  const res = await fetch(`${API}${path}`, {
    method,
    credentials: "include",
    headers: body ? { "Content-Type": "application/json" } : undefined,
    body: body ? JSON.stringify(body) : undefined,
  });
  let payload = null;
  try {
    payload = await res.json();
  } catch {
    // empty body
  }
  if (!res.ok) {
    const msg = formatApiErrorDetail(payload?.detail) || `Request failed (${res.status})`;
    const err = new Error(msg);
    err.status = res.status;
    throw err;
  }
  return payload;
}

export const memoryApi = {
  getSettings: () => call("/memory/settings"),
  setSettings: (memory_enabled) =>
    call("/memory/settings", { method: "POST", body: { memory_enabled } }),
  // Manual / end-of-thread writer trigger. Send the bare {role, content} for each turn.
  write: (sessionId, messages) =>
    call("/memory/write", {
      method: "POST",
      body: {
        session_id: sessionId,
        messages: messages.map((m) => ({ role: m.role, content: m.content || "" })),
      },
    }),
  list: () => call("/memory/list"),
  clearAll: () => call("/memory/clear", { method: "POST" }),
  remove: (id) => call(`/memory/${id}`, { method: "DELETE" }),
  audit: () => call("/memory/audit"),
};
